import React from 'react';
import _ from 'lodash';

import component, {classnames} from './component';
import Attention from './Attention';
import Link from './Link';
import {ArrowRight, LogoVkontakte} from './icons';


const dims = {
  'large':   {height: 792},
  'regular': {height: 704},
  'small':   {height: 312},
  'tiny':    {height: 88}
};

const dimKeys = _.keys(dims);

export default component('TopBanner', {

  propTypes: {
    size: React.PropTypes.oneOf(dimKeys),
    align: React.PropTypes.bool,
    data: React.PropTypes.object
  },

  getDefaultProps() {
    const size = dimKeys[dimKeys.length - 1];
    return {
      size,
      height: dims[size].height,
      align: true
    };
  },

  getDims() {
    return {
      height: dims[this.props.size].height
    };
  },

  render() {

    const attention = this.props.data && this.props.data.cursor('attention').deref() && this.props.data.cursor('attention');

    const cls = classnames(
      'TopBanner',
      {'TopBanner--NoBackground': !this.props.background},
      {'TopBanner--Background':    this.props.background},
      {'TopBanner--Attention': attention}
    );

    const stBackground = {
      backgroundImage: `url(${this.props.background || require('../img/headerBgLow.jpg')})`
    };

    _.merge(stBackground, this.getDims());

    return (
      <div className={cls} style={this.getDims()}>
        {
          this.props.background
            ? <div className='TopBanner-BackgroundBefore' style={stBackground}></div>
            : <div className='TopBanner-NoBackgroundBefore' style={stBackground}></div>
        }
        {
          this.props.social
          &&
          <div className="TopBanner-Social">
            <Link className="HomeSocial-Link" href="https://vk.com/pointblank?_smt=groups_list%3A1">
              <LogoVkontakte stroke="#dfe6ee" fill="#fff" className="TopBanner-SocialIcon" />
            </Link>
          </div>
        }
        <div className='TopBanner-OverlayBottom'>

          <div className='TopBanner-OverlayTop'>
            {
              attention
              &&
              <Attention onClose={() => {this.props.data.setIn(['attentionShown'], true); attention.remove()}} {...attention.toJS()} />
            }
            <div className={classnames('TopBanner-ContentContainer', {
                  'TopBanner-ContentContainer--AlignLeft':   !this.props.align,
                  'TopBanner-ContentContainer--AlignCenter':  this.props.align
                })}>
              {this.props.children}
            </div>
          </div>
        </div>
      </div>
    );
  }

});



// WEBPACK FOOTER //
// ./src/components/TopBanner.js